import { render } from "./JiraLinksPanel.vue?vue&type=template&id=c59edf52&scoped=true"
import script from "./JiraLinksPanel.vue?vue&type=script&lang=js"
export * from "./JiraLinksPanel.vue?vue&type=script&lang=js"

import "./JiraLinksPanel.vue?vue&type=style&index=0&id=c59edf52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59edf52"]])

export default __exports__